import React, { createContext, useEffect, useRef, useState } from "react";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import "../../css_files/Homepage/Homepage.css";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import axiosInstance, { getCookie } from "../../api";
import ChangePassword from "../Signin/ChangePassword";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import { registerWebPush } from "../registerWebPush";

export const triggerscroll = createContext();
function Homepage({ isloggedin, setisloggedin, setisloggedout }) {
  const insidehomepageref = useRef();
  const navbarRef = useRef();
  const [sidebarWidth, setSidebarWidth] = useState(0);
  const [expiredSession, setExpiredSession] = useState(false);
  const nav = useNavigate();
  const [userData, setUserData] = useState({
    role: "",
  });
  const [permissionsdata, setpermissionsdata] = useState([]);
  const [showRemainingDashboard, setShowRemainingDashboard] = useState(false);
  const [showchangepasswordform, setshowchangepasswordform] = useState(false);
  const sidebaranotherRef = useRef();
  const [mobileMode, setMobileMode] = useState(false);
  const [showtext, setshowtext] = useState(false);
  const [leftSide, setLeftSide] = useState(false);
  const [rightSide, setRightSide] = useState(false);

  function triggerscrollupwords() {
    if (insidehomepageref.current) {
      insidehomepageref.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }

  function triggerscrolldownwords() {
    if (insidehomepageref.current) {
      insidehomepageref.current.scrollTo({
        top: insidehomepageref.current.scrollHeight,
        behavior: "smooth",
      });
    }
  }

  useEffect(() => {
    if (isloggedin) {
      toast.success("Logged in Successfully", {
        position: "bottom-center",
        theme: "dark",
      });
      registerWebPush().then(async (token) => {
        if (token) {
          await axiosInstance.post(
            `${process.env.REACT_APP_API_URL}/api/devices/register`,
            {
              platform: "web",
              pushToken: token,
            }
          );
        }
      });
      setisloggedin(false);
    }
  }, [isloggedin]);

  useEffect(() => {
    if (getCookie("token")) {
      const url = `${process.env.REACT_APP_API_URL}/api/User/GetUserbyUserId`;
      axiosInstance
        .get(url)
        .then((res) => {
          setUserData(res.data);
          axiosInstance
            .get(
              `${process.env.REACT_APP_API_URL}/api/Permissions/GetPermissionByRole?role=${res.data.role}`
            )
            .then((res) => {
              setpermissionsdata(res.data);
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      nav("/");
    }
  }, []);

  const pathname = useLocation().pathname;

  useEffect(() => {
    if (pathname !== "/dashboard") setShowRemainingDashboard(false);
  }, [pathname]);

  return (
    <section className="homepage">
      <section className="inside-homepage">
        <Sidebar
          setSidebarWidth={setSidebarWidth}
          sidebaranotherRef={sidebaranotherRef}
          showtext={showtext}
          setshowtext={setshowtext}
          mobileMode={mobileMode}
          setLeftSide={setLeftSide}
          setRightSide={setRightSide}
        />
        <triggerscroll.Provider
          value={{
            triggerscrollupwords,
            triggerscrolldownwords,
            setExpiredSession,
            permissionsdata,
            userData,
            showRemainingDashboard,
            setShowRemainingDashboard,
          }}
        >
          <main
            style={{
              width:
                mobileMode === false
                  ? `calc(100vw - ${sidebarWidth}px)`
                  : "100vw",
            }}
          >
            <Navbar
              expiredSession={expiredSession}
              setshowchangepasswordform={setshowchangepasswordform}
              userData={userData}
              setisloggedout={setisloggedout}
              navbarRef={navbarRef}
              sidebarRef={sidebaranotherRef}
              setshowtext={setshowtext}
              setMobileMode={setMobileMode}
              leftSide={leftSide}
              rightSide={rightSide}
              setLeftSide={setLeftSide}
              setRightSide={setRightSide}
              mobileMode={mobileMode}
            />
            <section
              className="inside-homepage-content"
              ref={insidehomepageref}
              style={{
                height: `calc(100vh - ${navbarRef.current?.clientHeight}px)`,
              }}
            >
              <button
                id="goBackButtonHomepage"
                title="Go Back to Previous Screen"
                onClick={() => {
                  nav(-1);
                }}
              >
                <i className="fa-solid fa-arrow-left "></i>
              </button>
              <Outlet />
            </section>
          </main>
        </triggerscroll.Provider>
      </section>
      {showchangepasswordform && (
        <ChangePassword setshowchangepasswordform={setshowchangepasswordform} />
      )}
    </section>
  );
}

export default Homepage;
